import {
  HIDE_MESSAGE,
  INIT_URL,
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  SHOW_MESSAGE,
  SIGNIN_FACEBOOK_USER_SUCCESS,
  SIGNIN_GITHUB_USER_SUCCESS,
  SIGNIN_GOOGLE_USER_SUCCESS,
  SIGNIN_TWITTER_USER_SUCCESS,
  SIGNIN_USER_SUCCESS,
  SIGNOUT_USER_SUCCESS,
  SIGNUP_USER_SUCCESS,
  REFRESHTOKEN_USER_SUCCESS,
  CHANGEPASSWORD,
  CHANGEPASSWORD_SUCCESS,
  FORGOTPASSWORD_SUCCESS,
  CONFIRMFORGOTPASSWORD_SUCCESS,
  UPDATEACCOUNT,
  DELETEACCOUNT,
  ENABLEACCOUNT_SUCCESS,
  DISABLEACCOUNT_SUCCESS,
  CHECKTYPE_USER_SUCCESS,
  GETACCOUNT_SUCCESS
} from "constants/ActionTypes";

const INIT_STATE = {
  loader: false,
  alertMessage: '',
  showMessage: false,
  initURL: '',
  authUser: localStorage.getItem('user_id'),
  signedUpUser: false,
  refreshToken: localStorage.getItem('bms_refresh_token'),
  type: false,
  account: false
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SIGNUP_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        signedUpUser: action.payload
      }
    }
    case SIGNIN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case CHECKTYPE_USER_SUCCESS: {
      console.log('CHECKTYPE_USER_SUCCESS', action.payload);
      return {
        ...state,
        type: action.payload.type,
        accountId: action.payload.accountId
      }
    }
    case REFRESHTOKEN_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        accessToken: action.payload
      }
    }
    case CHANGEPASSWORD_SUCCESS: {
      console.log('CHANGEPASSWORD_SUCCESS', action.payload);
      return {
        ...state,
        changedPassword: action.payload
      }
    }
    case FORGOTPASSWORD_SUCCESS: {
      return {
        ...state,
        forgotPasswordRes: action.payload
      }
    }
    case CONFIRMFORGOTPASSWORD_SUCCESS: {
      console.log('CONFIRMFORGOTPASSWORD_SUCCESS', action.payload);
      return {
        ...state,
        confirmForgotPasswordRes: action.payload
      }
    }
    case INIT_URL: {
      return {
        ...state,
        initURL: action.payload
      }
    }
    case SIGNOUT_USER_SUCCESS: {
      return {
        ...state,
        authUser: null,
        initURL: '/',
        loader: false,
        type: false
      }
    }

    case SHOW_MESSAGE: {
      return {
        ...state,
        alertMessage: action.payload,
        showMessage: true,
        loader: false
      }
    }
    case HIDE_MESSAGE: {
      return {
        ...state,
        alertMessage: '',
        showMessage: false,
        loader: false
      }
    }

    case SIGNIN_GOOGLE_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_FACEBOOK_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_TWITTER_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case SIGNIN_GITHUB_USER_SUCCESS: {
      return {
        ...state,
        loader: false,
        authUser: action.payload
      }
    }
    case UPDATEACCOUNT: {
      return {
        ...state,
        loader: false,
        updatedAccount: action.payload
      }
    }
    case DELETEACCOUNT: {
      return {
        ...state,
        loader: false,
        deletedAccount: action.payload
      }
    }
    case ENABLEACCOUNT_SUCCESS: {
      return {
        ...state,
        enabledAccount: action.payload
      }
    }
    case DISABLEACCOUNT_SUCCESS: {
      console.log('DISABLEACCOUNT_SUCCESS', action.payload);
      return {
        ...state,
        disabledAccount: action.payload
      }
    }
    case ON_SHOW_LOADER: {
      return {
        ...state,
        loader: true
      }
    }
    case ON_HIDE_LOADER: {
      return {
        ...state,
        loader: false
      }
    }
    case GETACCOUNT_SUCCESS: {
      return {
        ...state,
        account: action.payload,
        updatedAccount: false
      }
    }
    default:
      return {
        ...state,
        changedPassword: false,
        updatedAccount: false,
        enabledAccount: false,
        disabledAccount: false
      }
  }
}
